export enum PepManagerApprovalEnum {
    All = 1,
    None,
    Yes,
    No
}
